import { Box, Grid, Typography } from '@mui/material';
import React, { ReactNode } from 'react'
import { StarBorderOutlined, StarOutlineRounded } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import { Product } from '../../types/Products';
import { useSelector } from 'react-redux';
import { RootState } from '../../Redux/store';

interface ProductProps {
    product: Product;
}

function ProductCard({ product }: ProductProps) {
      const { userDetails } = useSelector((state: RootState) => state.global)

    return (
        <Link to={`/${userDetails?.role}/products/product-details/${product.productId}`} className='text-decoration-none' state={{ product: product }}>
            <Grid
                key={product?.productId}
                size="auto"
                className="border-10 overflow-hidden d-flex flex-column"
                sx={{
                    width: {
                        xs: "200px",
                        md: "250px",
                        lg: "300px",
                    },
                    height: {
                        xs: "250px",
                        md: "350px",
                        lg: "400px",
                    },
                    flexShrink: 0,
                    border: '1px solid #ccc'
                }}
            >
                <Box
                    sx={{
                        flexGrow: 1,
                        minHeight: 0,
                        overflow: "hidden",
                    }}
                >
                    <Box
                        component="img"
                        className='bg-light'
                        src={product?.media?.[0]?.media_url}
                        alt={product?.productName}
                        sx={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                        }}
                    />
                </Box>
                <Box className='p-2'>
                    <Typography className="fw-bold fs-18 mt-2 text-dark">
                        {product?.productName}
                    </Typography>

                    <Box className="d-flex align-items-center gap-1 mb-2">
                        {[...Array(5)].map((_, index) =>
                            index < (product?.reviews?.length || 0) ? (
                                <StarOutlineRounded
                                    key={index}
                                    sx={{ color: "#FFD700", fontSize: 20 }}
                                />
                            ) : (
                                <StarBorderOutlined
                                    key={index}
                                    sx={{ color: "#808080", fontSize: 20 }}
                                />
                            )
                        )}

                        <Typography className="fs-12 text-dark ms-1">
                            {product?.reviews?.length || 0}
                        </Typography>
                    </Box>

                    <Typography className='fw-bold fs-18 align-items-baseline text-dark'>
                        {Number(product?.discounted_price).toLocaleString("en-US", {
                            style: "currency",
                            currency: "INR",
                        })}
                        &nbsp;{Number(product?.discount_percentage) > 0 && (<span className='over-line' style={{fontSize:"14px"}}>
                            {Number(product?.base_price).toLocaleString("en-US", {
                            style: "currency",
                            currency: "INR",
                        })}
                        </span>)} {Number(product?.discount_percentage) > 0 && (<span className='text-green'>&nbsp;{Number(product?.discount_percentage).toFixed(0)}% off</span>)}</Typography>
                </Box>
            </Grid>
        </Link>
    )
}

export default ProductCard
